const date = new Date();
const year = date.getFullYear();

const APPCONFIG = {
	brand: 'Karls Technology',
	year,
	copyright: '2020',
	productLink: 'https://forms.karlstechnology.com',
	reCAPTCHA: '6LfZwbcUAAAAAINSCYz4nbNni6e6mQNoaqfhK0cE',

	settings: {
		isDev: () => {
			return window.location.hostname === 'forms.beardeddevops.com' || ''
		},
		isProductionAPI: () => {
			return  APPCONFIG.apiURL !== 'https://forms.karlstechnology.com';
		},
		apiURL: window.location.hostname === 'forms.beardeddevops.com' ? 'https://dev.api.forms.beardeddevops.com' : 'https://api.forms.karlstechnology.com',
		apiVersion: 'v30'
	}
};

export default APPCONFIG;
